var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBwa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "247px",
    height: "247px",
    viewBox: "0 0 247 247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BWALogo-Copy-2",
    transform: "translate(-42.000000, -42.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(42.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#335EF7",
    cx: 123.5,
    cy: 123.5,
    r: 123.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 88.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4100732,53.0226526 C83.0055544,57.5006358 89.0333229,57.5006358 93.4933788,53.0226526 C102.260009,44.2207846 109.987558,28.7759404 116.676027,6.68812015 C119.664985,0.713879795 126.934071,-1.70765956 132.911986,1.27946062 C135.253972,2.44973344 137.15298,4.34757451 138.323973,6.68812015 L171,72",
    id: "Path-Copy",
    strokeDasharray: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,72 L32.676027,6.68812015 C35.6649846,0.713879795 42.9340713,-1.70765956 48.9119865,1.27946062 C51.2539718,2.44973344 53.1529803,4.34757451 54.323973,6.68812015 C66.0581622,31.5942598 74.3403606,48.8787106 79.1705684,58.5414723 C81.5676965,63.3368929 86.9493295,60.9680003 95.3154676,51.4347945",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwa);
export default __webpack_public_path__ + "static/media/bwa.519b90af9caee9030ead8583993fb783.svg";
export { ForwardRef as ReactComponent };